import { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { t, getLocale, setLocale } from '../i18n';

export default function Nav() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const locale = getLocale();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate('/login');
    setMenuOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  // Close menu when navigating
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  // Close menu when clicking outside
  useEffect(() => {
    if (!menuOpen) return;
    const handler = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  return (
    <nav className="nav" ref={menuRef}>
      <div className="nav-inner">
        <Link to="/dashboard" className="nav-logo" style={{ textDecoration: 'none', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
          <span style={{ fontFamily: 'Playfair Display', fontSize: 20, fontWeight: 700, color: 'var(--match-a)' }}>🍵 match-a</span>
          <span style={{ width: 1, height: 22, background: 'var(--border)', display: 'inline-block', flexShrink: 0 }} />
          <img src="/sccij-logo.svg" alt="SCCIJ" style={{ height: 20 }} />
        </Link>

        {/* Desktop nav links */}
        <div className="nav-links">
          <button className="btn btn-ghost" style={{ fontSize: 14 }} onClick={() => setLocale(locale === 'en' ? 'ja' : 'en')}>
            {locale === 'en' ? '日本語' : 'EN'}
          </button>
          {user?.is_admin && (
            <Link to="/admin" className="btn btn-ghost"
              style={{ fontWeight: isActive('/admin') ? 700 : 500, color: isActive('/admin') ? '#b91c1c' : '#ef4444', fontSize: 13 }}>
              Admin
            </Link>
          )}
          <Link to="/dashboard" className="btn btn-ghost"
            style={{ fontWeight: isActive('/dashboard') ? 600 : 400, color: isActive('/dashboard') ? 'var(--match-a)' : undefined }}>
            {t('matches')}
          </Link>
          <Link to="/availability" className="btn btn-ghost"
            style={{ fontWeight: isActive('/availability') ? 600 : 400, color: isActive('/availability') ? 'var(--match-a)' : undefined }}>
            {t('profileTabAvailability')}
          </Link>
          <Link to="/profile" className="btn btn-ghost"
            style={{ fontWeight: isActive('/profile') ? 600 : 400, color: isActive('/profile') ? 'var(--match-a)' : undefined }}>
            {t('profile')}
          </Link>
          <Link to="/faq" className="btn btn-ghost"
            style={{ fontWeight: isActive('/faq') ? 600 : 400, color: isActive('/faq') ? 'var(--match-a)' : undefined, fontSize: 13 }}>
            {t('faqNav')}
          </Link>
          <div className="avatar" style={{ background: user?.avatar_color, cursor: 'default', marginLeft: 4 }} title={user?.name}>
            {user?.name?.[0]}
          </div>
          <button className="btn btn-ghost" onClick={handleLogout} style={{ fontSize: 14 }}>
            {t('signOut')}
          </button>
        </div>

        {/* Hamburger button — mobile only */}
        <button
          className="nav-hamburger"
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="nav-mobile-menu">
          <button className="nav-mobile-item" onClick={() => { setLocale(locale === 'en' ? 'ja' : 'en'); setMenuOpen(false); }}>
            {locale === 'en' ? '日本語' : 'EN'}
          </button>
          {user?.is_admin && (
            <Link to="/admin" className="nav-mobile-item" style={{ color: '#ef4444' }}>Admin</Link>
          )}
          <Link to="/dashboard" className="nav-mobile-item" style={{ color: isActive('/dashboard') ? 'var(--match-a)' : undefined }}>
            {t('matches')}
          </Link>
          <Link to="/availability" className="nav-mobile-item" style={{ color: isActive('/availability') ? 'var(--match-a)' : undefined }}>
            {t('profileTabAvailability')}
          </Link>
          <Link to="/profile" className="nav-mobile-item" style={{ color: isActive('/profile') ? 'var(--match-a)' : undefined }}>
            {t('profile')}
          </Link>
          <Link to="/faq" className="nav-mobile-item" style={{ color: isActive('/faq') ? 'var(--match-a)' : undefined }}>
            {t('faqNav')}
          </Link>
          <button className="nav-mobile-item" onClick={handleLogout}>
            {t('signOut')}
          </button>
        </div>
      )}
    </nav>
  );
}
